export default "__VITE_ASSET__CQwMvCvL__"